import React from "react";

import { Slot } from "~/components/slot";
import { cx } from "~/tools/class-variance";

import styles from "./_join.module.css";

export interface JoinItemProps {
	className?: string;
	children: React.ReactNode;
}

export const JoinItem = React.forwardRef<HTMLDivElement, JoinItemProps>(({ className, ...props }, ref) => (
	<Slot className={cx(styles.joinItem, className)} ref={ref} {...props} />
));

if (import.meta.env.DEV) {
	JoinItem.displayName = "JoinItem";
}
